import { motion } from "framer-motion";
import {
  UtensilsCrossed,
  Plane,
  ShoppingCart,
  Fuel,
  Apple,
  Zap,
  Film,
  Globe,
  CreditCard,
} from "lucide-react";

const ICON_MAP = {
  UtensilsCrossed: UtensilsCrossed,
  Plane: Plane,
  ShoppingCart: ShoppingCart,
  Fuel: Fuel,
  Apple: Apple,
  Zap: Zap,
  Film: Film,
  Globe: Globe,
};

export default function CategoryCheatSheet({ categories }) {
  if (!categories || categories.length === 0) return null;

  return (
    <div
      className="glass-card rounded-2xl p-6 transition-all duration-300 h-full"
      data-testid="category-cheatsheet"
    >
      <p className="text-xs font-medium text-white/30 uppercase tracking-[0.15em] mb-5">
        Category Cheat Sheet
      </p>

      <div className="grid grid-cols-2 gap-2.5">
        {categories.map((cat, i) => {
          const IconComp = ICON_MAP[cat.icon] || CreditCard;

          return (
            <motion.div
              key={cat.category + i}
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.3, delay: i * 0.04 }}
              className="flex items-center gap-2.5 p-2.5 rounded-xl bg-white/[0.02] hover:bg-white/[0.05] transition-colors border border-white/[0.04] hover:border-white/[0.08]"
              data-testid={`category-item-${i}`}
            >
              <div className="w-8 h-8 rounded-lg bg-white/[0.04] border border-white/[0.06] flex items-center justify-center flex-shrink-0">
                <IconComp className="w-4 h-4 text-white/30" />
              </div>
              <div className="min-w-0">
                <p className="text-[10px] text-white/25 font-medium truncate">
                  {cat.category}
                </p>
                <p
                  className="text-xs font-semibold text-white/70 truncate"
                  data-testid={`category-best-card-${i}`}
                >
                  {cat.best_card}
                </p>
              </div>
            </motion.div>
          );
        })}
      </div>
    </div>
  );
}
